import React from 'react';
import { BRAIN_STATS } from '../../mocks/brain';

/**
 * T13.5 — headline orchestrator stats above the graph.
 */
function OrchestratorStatsBar({ activeCount, totalAgents }) {
  return (
    <div className="brain-stats">
      <div className="brain-stats__item">
        <span>Decisions</span>
        <strong>{BRAIN_STATS.decisions.toLocaleString()}</strong>
      </div>
      <div className="brain-stats__item">
        <span>Autonomy rate</span>
        <strong>{Math.round(BRAIN_STATS.autonomousRate * 100)}%</strong>
      </div>
      <div className="brain-stats__item">
        <span>Tasks routed today</span>
        <strong>{BRAIN_STATS.routedToday}</strong>
      </div>
      <div className="brain-stats__item">
        <span>Escalations</span>
        <strong>{BRAIN_STATS.escalations}</strong>
      </div>
      <div className="brain-stats__item">
        <span>Fleet active</span>
        <strong>{activeCount} / {totalAgents}</strong>
      </div>
    </div>
  );
}

export default OrchestratorStatsBar;
